import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function identifyPlant(imageBase64, deviceId) {
  const res = await axios.post(`${API}/plants/identify`, {
    image_base64: imageBase64,
    device_id: deviceId,
  });
  return res.data;
}

export async function askQuestion(question, deviceId, imageBase64 = null) {
  const res = await axios.post(`${API}/plants/ask`, {
    question,
    device_id: deviceId,
    image_base64: imageBase64,
  });
  return res.data;
}

export async function analyzeYard(imageBase64, deviceId, notes = "") {
  const res = await axios.post(`${API}/yard/analyze`, {
    image_base64: imageBase64,
    device_id: deviceId,
    notes,
  });
  return res.data;
}

export async function savePlant(plantData) {
  const res = await axios.post(`${API}/plants/save`, plantData);
  return res.data;
}

export async function getSavedPlants(deviceId) {
  const res = await axios.get(`${API}/plants/saved/${deviceId}`);
  return res.data;
}

export async function deleteSavedPlant(plantId) {
  const res = await axios.delete(`${API}/plants/saved/${plantId}`);
  return res.data;
}

export async function addShoppingItem(itemData) {
  const res = await axios.post(`${API}/shopping-list/items`, itemData);
  return res.data;
}

export async function getShoppingList(deviceId) {
  const res = await axios.get(`${API}/shopping-list/${deviceId}`);
  return res.data;
}

export async function updateShoppingItem(itemId, updateData) {
  const res = await axios.put(`${API}/shopping-list/items/${itemId}`, updateData);
  return res.data;
}

export async function deleteShoppingItem(itemId) {
  const res = await axios.delete(`${API}/shopping-list/items/${itemId}`);
  return res.data;
}

export async function getFile(path) {
  const res = await axios.get(`${API}/files/${path}`, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}
